import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteTaxSaga,
  getTaxDetailsSaga,
  getTaxListSaga,
} from "src/store/tax/saga";
import { TaxDetailDto, TaxDto } from "src/store/tax/type";
import TaxCreateForm from "./create";
import TaxEditForm from "./edit";
const TaxPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<TaxDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<TaxDetailDto>();
  const columns = [
    {
      text: t("Tax.Name"),
      dataField: "Name",
    },
    {
      text: t("Tax.Value"),
      dataField: "Value",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Tax.PageTitle")}
        metaTag={t("Tax.MetaTag")}
        gridProps={{
          addTitle: t("Tax.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getTaxListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getTaxDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: TaxDto) =>
              t("Tax.DeleteQA", {
                name: data.Name,
              }),
            action: deleteTaxSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <TaxCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getTaxListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <TaxEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getTaxListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default TaxPage;
